import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-6',
    general: 'flex gap-5 max-sm:flex-col max-sm:gap-6',
    name: 'w-full',
    age: 'w-[180px] max-sm:w-full'
  }
});
